import React from 'react'

const AuthorSuggestions = ({ authorSuggestion, styles }) => {
  if (!authorSuggestion) {
    return null
  }

  return (
    <p className={styles.authorText}>
      {'We found an author by that name: '}
      <a className={styles.authorLink} href={authorSuggestion.url}>
        {authorSuggestion.username}
      </a>
    </p>
  )
}

export default AuthorSuggestions
